import React, { useEffect, useState } from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { ResponsiveImage, Modal } from '../../components';

import ImageCarousel from './ImageCarousel/ImageCarousel';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';
import IconCollection from '../../components/IconCollection/IconCollection';
import ContainerLayout from '../../components/ContainerLayout';
import SectionGallery from './SectionGallery';

const SectionHero = props => {
  const intl = useIntl();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const {
    title,
    listing,
    isOwnListing,
    editParams,
    currentUser,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    noPayoutDetailsSetWithOwnListing,
  } = props;

  const hasImages = listing.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const variants = firstImage
    ? Object.keys(firstImage?.attributes?.variants).filter(k => k.startsWith('scaled'))
    : [];




  // action bar allignment
  const hasBothActionBar = noPayoutDetailsSetWithOwnListing && isOwnListing;
  const hasSingleActionBar = (noPayoutDetailsSetWithOwnListing || isOwnListing) && !hasBothActionBar;

  const sectionStyle = hasBothActionBar
    ? { marginTop: '0px' }
    : hasSingleActionBar
      ? { marginTop: '100px' }
      : {};

  const actionBarStyle = hasBothActionBar
    ? { top: '-150px' }
    : hasSingleActionBar
      ? { top: '-80px' }
      : {};



  return (
    <ContainerLayout>
      <section
        // style={sectionStyle}
        className={css.sectionHero}
        data-testid="hero"
      >
        {/* action bar UI is here */}

        <div className={css.imageWrapperForSectionHero} onClick={handleViewPhotosClick}>
          {mounted && listing.id && isOwnListing ? (
            <div
              // style={actionBarStyle}
              onClick={e => e.stopPropagation()}
              className={css.actionBarContainerForHeroLayout}
            >
              {noPayoutDetailsSetWithOwnListing ? (
                <ActionBarMaybe
                  className={css.actionBarForHeroLayout}
                  isOwnListing={isOwnListing}
                  listing={listing}
                  showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                  currentUser={currentUser}
                />
              ) : null}

              <ActionBarMaybe
                className={css.actionBarForHeroLayout}
                isOwnListing={isOwnListing}
                listing={listing}
                editParams={editParams}
                currentUser={currentUser}
              />
            </div>
          ) : null}

          {/* <ResponsiveImage
          rootClassName={css.rootForImage}
          alt={title}
          image={firstImage}
          variants={variants}
        /> */}
          {/* {viewPhotosButton} */}
        </div>
        {/* action bar UI is here */}

        {/* Gallary UI is here */}
        
        <SectionGallery
          listing={listing}
          variantPrefix={['scaled-medium-2x']}
        />

      </section>
    </ContainerLayout>
  );
};

export default SectionHero;
